'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Facilities(_ref) {
  var i18n = _ref.i18n,
      items = _ref.items;

  var list = {};
  items.forEach(function (item) {
    list[item.type] = list[item.type] || [];
    list[item.type].push(item.name);
  });

  return _react2.default.createElement(
    'div',
    null,

    /* TODO: remove the check for 'available services' */
    (0, _keys2.default)(list).map(function (key) {
      return _react2.default.createElement(
        'div',
        {
          className: key === 'service' ? 'available-services' : key + '-facilities',
          key: key
        },
        _react2.default.createElement(
          'div',
          { className: 'title-box' },
          _react2.default.createElement(
            'h3',
            null,
            key === 'service' ? i18n.hotelInformation.availableServices : i18n.hotelInformation[key + 'Facilities']
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'content-box' },
          _react2.default.createElement(
            'ul',
            null,
            list[key].map(function (item) {
              return _react2.default.createElement(
                'li',
                { key: item },
                item
              );
            })
          )
        )
      );
    })
  );
} // Facilities

Facilities.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  items: _react.PropTypes.array.isRequired
};

exports.default = Facilities;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Facilities.js
// module id = 1200
// module chunks = 0